import type { SVGProps } from 'react';
const SvgSpaceBar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#space_bar_svg__a)">
      <path fill="currentColor" d="M18 9v4H6V9H4v6h16V9h-2Z" />
    </g>
    <defs>
      <clipPath id="space_bar_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSpaceBar;
